/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".loading__veil[_ngcontent-%COMP%]{z-index:9999;position:absolute;top:0;left:0;width:100vw;height:100vh;display:flex;justify-content:center;align-items:center;background-color:rgba(var(--color-background-rgb),.5)}.loading__veil__spinner[_ngcontent-%COMP%]{width:64px;height:64px}"];
export { styles as styles };
